import React from "react"
import { mutationRequest } from "../../util/request"
import { Button } from "../../components/shared/Button"
import { DeleteWarningGauntlet } from "../../components/shared/DeleteWarningGauntlet"
import { root_path } from "../../routes"

interface User {
  id: number
}

interface UserDeleteFormProps {
  user: User
}

export const UserDeleteForm: React.FC<UserDeleteFormProps> = ({ user }) => {
  const handleDeleteUser = () => {
    if (
      window.confirm(
        "Are you sure you want to delete your account? This action cannot be undone.",
      )
    ) {
      mutationRequest({
        path: `/api/v1/users/${user.id}`,
        options: { method: "DELETE" },
      }).then(() => {
        redirectHome()
      })
    }
  }

  return (
    <DeleteWarningGauntlet subject="your account">
      <Button
        bg="bg-red-600"
        className="hover:bg-red-700"
        onClick={handleDeleteUser}
      >
        Delete Account
      </Button>
    </DeleteWarningGauntlet>
  )
}

const redirectHome = () => {
  window.location.href = root_path()
}
